<template>
    <b-modal
        hide-footer
        id="info-quantity"
        title="Tires"
        v-model="visible"
        size="md"
    >
        <p>Select whether you are running singles, dual or triples on the front and / or rear axles.</p>
    </b-modal>
</template>

<script>
export default {
    data: () => ({
        visible: false,
    }),
}
</script>
